import { findPageGrupoDeCliente, criarGrupoDeCliente, atualizarGrupoDeCliente, 
	deletarGrupoDeCliente, listarGruposDeCliente, findGruposVinculadosComCliente, 
	vincularGrupoDeCliente, desvincularGrupoDeCliente, possuiGrupoDeClienteByGrupoEconomico } from "@/api/grupoDeCliente";
import { GrupoDeCliente } from "@/models";
import { GrupoDeClienteServiceAdapter } from "@/usecases/cliente/adapter/GrupoDeClienteServiceAdapter";
import { AxiosRequestConfig } from "axios";
import { injectable } from "inversify-props";

@injectable()
export class GrupoDeClienteService implements GrupoDeClienteServiceAdapter {
	findPageGrupoDeCliente = async (params?: any, config?: AxiosRequestConfig) => await findPageGrupoDeCliente(params, config)
	criarGrupoDeCliente = async (grupoDeCliente: GrupoDeCliente) => await criarGrupoDeCliente(grupoDeCliente)
	atualizarGrupoDeCliente = async (grupoDeCliente: GrupoDeCliente) => await atualizarGrupoDeCliente(grupoDeCliente)
	deletarGrupoDeCliente = async (grupoDeClienteId: string) => await deletarGrupoDeCliente(grupoDeClienteId)
	listarGruposDeCliente = async (params?: any, config?: AxiosRequestConfig) => await listarGruposDeCliente(params, config)
	findGruposVinculadosComCliente = async (params?: any, config?: AxiosRequestConfig) => await findGruposVinculadosComCliente(params, config)
	possuiGrupoDeClienteByGrupoEconomico = async (clienteId: string, grupoId: string) => await possuiGrupoDeClienteByGrupoEconomico(clienteId, grupoId)	
	vincularGrupoDeCliente = async (clienteId: string, grupoId: string) => await vincularGrupoDeCliente(clienteId, grupoId)
	desvincularGrupoDeCliente = async (grupoId: string, clienteId: string) => await desvincularGrupoDeCliente(grupoId, clienteId)

}